import { AxiosResponse } from 'axios';
import BaseApi from './BaseApi';
import {
  IItemDetailResponse,
  IItemRecallRequestResponse,
  IItemsListResponse,
  IPlaceItemRequestPayload,
  IPlaceItemRequestResponse,
} from './types/marketplace';

const MarketplaceApi = {
  getItemsList: async (): Promise<AxiosResponse<IItemsListResponse>> => {
    return await BaseApi.getRequest(`/marketplace-list`);
  },
  itemRecallRequest: async (walletAddress: string): Promise<AxiosResponse<IItemRecallRequestResponse>> => {
    return await BaseApi.getRequest(`/item-recall-request?walletAddress=${walletAddress}`);
  },
  placeItemRequest: async (
    itemId: number,
    data: IPlaceItemRequestPayload,
  ): Promise<AxiosResponse<IPlaceItemRequestResponse>> => {
    return await BaseApi.postRequest(`/item-request/${itemId}`, data);
  },
  getItemDetail: async (id: number, walletAddress?: string): Promise<AxiosResponse<IItemDetailResponse>> => {
    return await BaseApi.getRequest(`/item/${id}?walletAddress=${walletAddress ?? null}`);
  },
  itemBoughtRequest: async (
    itemId: number,
    walletAddress: string,
    hash: string,
  ): Promise<AxiosResponse<IItemDetailResponse>> => {
    return await BaseApi.getRequest(
      `/item-bought-successfull?walletAddress=${walletAddress}&itemId=${itemId}&hash=${hash}`,
    );
  },
  itemBidRequest: async (
    itemId: number,
    walletAddress: string,
    hash: string,
  ): Promise<AxiosResponse<IItemDetailResponse>> => {
    return await BaseApi.getRequest(
      `/item-bid-successfull?walletAddress=${walletAddress}&itemId=${itemId}&hash=${hash}`,
    );
  },
  reclaimRequest: async (walletAddress: string, hash: string): Promise<AxiosResponse<IItemDetailResponse>> => {
    return await BaseApi.getRequest(`/reclaim-success?walletAddress=${walletAddress}&hash=${hash}`);
  },
};

export default MarketplaceApi;
